module.exports = __webpack_public_path__ + "static/media/tab-1-image-1.180d4409.png";